const PORTAL_LOGIN_PATH = "/portal/login";

export const buildCurrentPath = (location) => {
    const pathname = location?.pathname || "/";
    const search = location?.search || "";
    const hash = location?.hash || "";
    return `${pathname}${search}${hash}`;
};

export const buildPortalLoginUrl = (nextPath) => {
    if (!nextPath) {
        return PORTAL_LOGIN_PATH;
    }

    return `${PORTAL_LOGIN_PATH}?next=${encodeURIComponent(nextPath)}`;
};

export const redirectToPortalLogin = (nextPath, { replace = false } = {}) => {
    const loginUrl = buildPortalLoginUrl(nextPath);

    if (replace) {
        window.location.replace(loginUrl);
        return;
    }

    window.location.href = loginUrl;
};
